import React from 'react';
import './MobileWidePages.css';

const allocationFields = [
  ['seDayDual', 'SE day dual'],
  ['seDayPic', 'SE day PIC'],
  ['seNightDual', 'SE night dual'],
  ['seNightPic', 'SE night PIC'],
  ['meDayDual', 'ME day dual'],
  ['meDayPic', 'ME day PIC'],
  ['meDayCopilot', 'ME day co-pilot'],
  ['meDayPiUs', 'ME day PI (US)'],
  ['meNightDual', 'ME night dual'],
  ['meNightPic', 'ME night PIC'],
  ['meNightCopilot', 'ME night co-pilot'],
  ['meNightPiUs', 'ME night PI (US)'],
  ['instrumentFlight', 'Instrument'],
  ['otherFlying', 'Other flying'],
];

export default function MobilePilotLogbook({
  rows,
  aircraftMap,
  totals,
  formatTotal,
  normalizeRow,
  updateCell,
  commitDate,
  updateUtc,
  commitUtc,
  commitHours,
  rowFieldErrors = {},
  utcFieldErrors = {},
  getFieldErrorKey = () => undefined,
  isSelectableManualRow = () => false,
  selectedManualRowIds = {},
  toggleManualRowSelection = () => {},
  savingRowId = '',
}) {
  return (
    <div className="mobile-wide-page mobile-pilot-logbook">
      <section className="mobile-wide-summary">
        <strong>Totals carried forward</strong>
        <div className="mobile-wide-summary__grid">
          {allocationFields.map(([field, label]) => (
            <div key={field}><span>{label}</span><b>{formatTotal(totals[field])}</b></div>
          ))}
        </div>
      </section>

      <div className="mobile-wide-list">
        {rows.map((row) => {
          const normalized = normalizeRow(row, aircraftMap[row.aircraftId]);
          const flightTime = row.totalTime || row.flightTime || row.autoDuration || '';
          const dateError = rowFieldErrors[getFieldErrorKey(row.bookingId, 'date')];
          const depUtcError = utcFieldErrors[getFieldErrorKey(row.bookingId, 'depUtc')] || rowFieldErrors[getFieldErrorKey(row.bookingId, 'depUtc')];
          const arrUtcError = utcFieldErrors[getFieldErrorKey(row.bookingId, 'arrUtc')] || rowFieldErrors[getFieldErrorKey(row.bookingId, 'arrUtc')];
          const remarksError = rowFieldErrors[getFieldErrorKey(row.bookingId, 'notes')];
          const selectable = isSelectableManualRow(row);
          const isSaving = savingRowId === String(row.bookingId);
          return (
            <article className="mobile-wide-card" key={row.bookingId}>
              <header>
                <div>
                  {selectable ? (
                    <label className="mobile-wide-card__select">
                      <input
                        type="checkbox"
                        checked={Boolean(selectedManualRowIds[String(row.bookingId)])}
                        onChange={(event) => toggleManualRowSelection(String(row.bookingId), event.target.checked)}
                        aria-label={`Select manual entry ${row.bookingId}`}
                      />
                      {' '}Manual entry
                    </label>
                  ) : null}
                  <strong>{normalized.aircraftRegistration || 'Aircraft'}</strong><span>{normalized.aircraftType || 'Type not set'}</span>
                </div>
                <time>{row.date || 'Date not set'}</time>
              </header>
              <div className="mobile-wide-card__route">{normalized.from || '—'} → {normalized.to || '—'}</div>
              <div className="mobile-wide-card__facts">
                <div><span>UTC</span><b>{normalized.depUtc || '—'}–{normalized.arrUtc || '—'}</b></div>
                <div><span>Flight time</span><b>{flightTime || 'See allocations'}</b></div>
                <div><span>Pilot / PIC</span><b>{normalized.pilot || normalized.student || '—'}</b></div>
              </div>
              <details>
                <summary>View and edit full entry</summary>
                <div className="mobile-wide-fields">
                  <MobileField label="Date" value={row.date} onChange={(value) => updateCell(row.bookingId, 'date', value)} onBlur={() => commitDate(row.bookingId)} error={dateError} />
                  <MobileField label="Type" value={normalized.aircraftType} onChange={(value) => updateCell(row.bookingId, 'aircraftType', value)} />
                  <MobileField label="Registration" value={normalized.aircraftRegistration} onChange={(value) => updateCell(row.bookingId, 'aircraftRegistration', value)} />
                  <MobileField label="Pilot" value={normalized.pilot} onChange={(value) => updateCell(row.bookingId, 'pilot', value)} />
                  <MobileField label="Student" value={normalized.student} onChange={(value) => updateCell(row.bookingId, 'student', value)} />
                  <MobileField label="From" value={normalized.from} onChange={(value) => updateCell(row.bookingId, 'from', value)} />
                  <MobileField label="To" value={normalized.to} onChange={(value) => updateCell(row.bookingId, 'to', value)} />
                  <MobileField label="Departure UTC" value={normalized.depUtc} onChange={(value) => updateUtc(row.bookingId, 'depUtc', value)} onBlur={() => commitUtc(row.bookingId, 'depUtc')} error={depUtcError} />
                  <MobileField label="Arrival UTC" value={normalized.arrUtc} onChange={(value) => updateUtc(row.bookingId, 'arrUtc', value)} onBlur={() => commitUtc(row.bookingId, 'arrUtc')} error={arrUtcError} />
                  {allocationFields.map(([field, label]) => (
                    <MobileField key={field} label={label} value={row[field]} onChange={(value) => updateCell(row.bookingId, field, value)} onBlur={() => commitHours(row.bookingId, field)} error={rowFieldErrors[getFieldErrorKey(row.bookingId, field)]} />
                  ))}
                  <MobileField label="Remarks" value={normalized.notes} onChange={(value) => updateCell(row.bookingId, 'notes', value)} error={remarksError} />
                </div>
                {isSaving ? <div className="mobile-wide-card__saving">Saving...</div> : null}
              </details>
            </article>
          );
        })}
      </div>
    </div>
  );
}

function MobileField({ label, value, onChange, onBlur, error }) {
  return (
    <label>
      <span>{label}</span>
      <input value={value || ''} onChange={(event) => onChange(event.target.value)} onBlur={onBlur} />
      {error ? <div className="mobile-wide-field__error">{error}</div> : null}
    </label>
  );
}